import { Route, Routes } from "react-router-dom";
import * as Page from "./pages";

export const RouteNavigation = {
  home: "/",
  about: "/about-us",
  contact: "/contact-us",
  partnerhip: "/partnership",
  products: "/products",
  service: "/service",
  solution: "/solutions",
  productDetail: "/products/product-details",
  ScheduleDemo: "/home-page/schedule-demo",
  blog: "/blog",
  blogDetail: "/blog/:id",
  faq: "/faq",
  termsAndCondition: "/terms-and-conditions",
  privacyPolicy: "/privacy-policy",
};

const GenericRoutes = () => {
  return (
    <>
      <Routes>
        <Route path={RouteNavigation.home} element={<Page.Home />} />
        <Route path={RouteNavigation.about} element={<Page.AboutUs />} />
        <Route path={RouteNavigation.contact} element={<Page.ContactUs />} />
        <Route
          path={RouteNavigation.partnerhip}
          element={<Page.Partnership />}
        />
        <Route path={RouteNavigation.products} element={<Page.Products />} />
        <Route path={RouteNavigation.solution} element={<Page.Features />} />
        <Route path={RouteNavigation.blog} element={<Page.Blog />} />
        <Route
          path={RouteNavigation.blogDetail}
          element={<Page.BlogDetail />}
        />
        <Route path="/product/:id" element={<Page.ProductDetails />} />
        <Route
          path={RouteNavigation.ScheduleDemo}
          element={<Page.ScheduleDemo />}
        />
        <Route path={RouteNavigation.faq} element={<Page.FAQ />} />
        <Route
          path={RouteNavigation.termsAndCondition}
          element={<Page.TermsAndCondition />}
        />
        <Route
          path={RouteNavigation.privacyPolicy}
          element={<Page.PrivacyPolicy />}
        />
      </Routes>
    </>
  );
};
export default GenericRoutes;
